<div class="contents" data-testid="contents">
    <div class="contents__content" data-testid="contents-content">
        <app-table-toolbar
            [placeholder]="'Search Host Name, Address, City, Postal Code, DMA Name or #Tag '"
            [buttons]="toolbarButtons()"
            (actionClick)="onToolbarAction($event)">
            <ntv-button leftActions variant="accent" size="xl" rounded="md">
                <div class="main-btn text-white" data-testid="main-btn">
                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#' + icons['filter']"></use>
                    </svg>
                    <span>Filter by</span>
                </div>
            </ntv-button>
        </app-table-toolbar>

        <div class="contents__content-table" data-testid="contents-content-table">
            <app-table
                [columns]="contentColumns"
                [data]="contentData"
                [tableTitle]="'Contents'"
                [tableHeight]="'600px'"
                [paddingY]="'14px'"
                [hasCheckBox]="true"
                (actionClick)="onActionClick($event)"
                (cellClick)="onCellClick($event)"
                (selectionChange)="onSelectionChange($event)">
            </app-table>
        </div>
    </div>
</div>
